import { HubtypeQueue } from '@hubtype/data-access-models'

import { HtQueueLocale } from '../cms/hubtype/common'
import {
  ContentFieldsBase,
  ContentType,
  NonMessageContentType,
  QueueLocale,
} from '.'

export class QueueFields extends ContentFieldsBase {
  constructor(
    public projectName = '',
    public name = '',
    public isInvalid = false
  ) {
    super()
  }

  contentType(): NonMessageContentType {
    return ContentType.QUEUE
  }

  static fromHubtype(content: HubtypeQueue): QueueFields {
    const newQueue = new QueueFields()
    newQueue.id = content.id
    newQueue.projectName = content.projectName
    newQueue.name = content.name
    return newQueue
  }

  static fromHubtypeCMS(component: QueueLocale): QueueFields {
    const newQueue = new QueueFields()
    newQueue.id = component.id
    newQueue.name = component.name
    newQueue.projectName = component.projectName
    newQueue.isInvalid = component.isInvalid
    return newQueue
  }

  toHubtypeCMS(locale: string): HtQueueLocale | undefined {
    if (!this.id || !this.name) return undefined
    const node: HtQueueLocale = {
      id: this.id,
      name: this.name,
      locale: locale,
    }
    return node
  }

  getValuesByLocale(locale: string): QueueLocale | undefined {
    if (!this.id || !this.name) return undefined
    const node: QueueLocale = {
      id: this.id,
      name: this.name,
      projectName: this.projectName,
      isInvalid: this.isInvalid,
      locale,
    }
    return node
  }

  static getCopy(content: QueueFields): QueueFields {
    const newQueue = new QueueFields()
    Object.assign(newQueue, content)
    return newQueue
  }
}
